module.exports = {
  "/": {
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    },
    "error": [
      "NOT_AUTHENTICATED"
    ]
  }
};